const supportedCategoryGroupsNames = ['AMERICAN FOOTBALL', 'BASEBALL', 'BASKETBALL', 'FOOTBALL', 'ICE HOCKEY'];

export const supportedCategoryGroupsQuery = {
  bool: {
    should: supportedCategoryGroupsNames.map(categoryGroupName => ({
      term: {
        categoryGroupName,
      },
    })),
  },
};
